import { createSlice } from '@reduxjs/toolkit';
import { SITE_LANGUAGES } from '../constants';

export const generalSlice = createSlice({
  name: 'general',
  initialState: {
    sidebarOpened: false,
    siteLanguage: '3',
    siteLanguageSF: 'en',
    currentPage: '',
    headerTheme: 'header',
  },
  reducers: {
    setSidebarState: (state, payload = false) => {
      state.sidebarOpened = payload.payload;
    },
    setSiteLanguage: (state, payload) => {
      state.siteLanguage = payload.payload;
      state.siteLanguageSF = SITE_LANGUAGES[payload.payload] ?? 'en';
    },
    setCurrentPage: (state, payload) => {
      state.currentPage = payload.payload;
    },
    setHeaderTheme: (state, payload) => {
      state.headerTheme = payload.payload ? payload.payload : 'header';
    },
  },
})

export const { setSidebarState, setCurrentPage, setHeaderTheme, setSiteLanguage } = generalSlice.actions

export default generalSlice.reducer